// extracted by mini-css-extract-plugin
export default {"tabs":"B8-z","tablist":"C8-z","tablistItem":"D8-z"};